import { _ as _sliced_to_array } from "@swc/helpers/_/_sliced_to_array";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useState, useEffect } from "react";
import { NumberFormat, filterTextAndNum } from "utils/HelperFunction";
import ThaiBahtText from "thai-baht-text";
import { Page, Text, View, Document, StyleSheet, Font, Image } from "@react-pdf/renderer";
import thsarabun from "fonts/THSarabunNew.ttf";
import thsarabunBold from "fonts/THSarabunNewBold.ttf";
import moment from "moment";
import "moment/locale/th";
Font.register({
    family: "THSarabun",
    fonts: [
        {
            src: thsarabun
        },
        {
            src: thsarabunBold,
            fontWeight: "bold"
        }
    ]
});
// Styles
var styles = StyleSheet.create({
    page: {
        fontFamily: "THSarabun",
        fontSize: 12,
        padding: 30,
        backgroundColor: "#fff",
        lineHeight: 1.4
    },
    headerRow: {
        flexDirection: "row",
        justifyContent: "space-between",
        marginBottom: 12,
        alignItems: "center"
    },
    logo: {
        width: 90
    },
    logoBank: {
        width: 40
    },
    subTitle: {
        fontSize: 12,
        marginBottom: 2,
        color: "#333"
    },
    title: {
        fontSize: 18,
        fontWeight: "bold",
        color: "#B00412"
    },
    titleBox: {
        textAlign: "right"
    },
    titleCenter: {
        textAlign: "center"
    },
    sectionGroup: {
        flexDirection: "row",
        justifyContent: "space-between",
        marginBottom: 12
    },
    col6: {
        flex: 1
    },
    textEnd: {
        textAlign: "right"
    },
    sectionBox: {
        flex: 1,
        padding: 6,
        marginRight: 8,
        borderBottom: "1px solid #CCC"
    },
    sectionLabel: {
        fontSize: 12,
        color: "#555"
    },
    sectionValue: {
        fontSize: 12,
        fontWeight: "bold",
        marginTop: 2
    },
    docInfoBox: {
        flex: 1,
        padding: 6,
        marginLeft: 8,
        borderRadius: 4,
        backgroundColor: "#FDECEC"
    },
    docInfoRow: {
        flexDirection: "row",
        justifyContent: "space-between",
        marginBottom: 4
    },
    docLabel: {
        fontSize: 12,
        color: "#333"
    },
    docValue: {
        fontSize: 12,
        fontWeight: "bold"
    },
    table: {
        display: "table",
        width: "auto",
        marginTop: 2
    },
    tableRow: {
        flexDirection: "row"
    },
    tableHeader: {
        flex: 1,
        borderRight: "1px solid #E2E8F0",
        backgroundColor: "#F6E1E3",
        padding: 6,
        fontSize: 12,
        fontWeight: "bold",
        textAlign: "center"
    },
    tableCell: {
        flex: 1,
        borderRight: "0px solid #E2E8F0",
        borderTop: "0px solid #E2E8F0",
        padding: 5,
        fontSize: 11,
        textAlign: "center"
    },
    footer: {
        marginTop: 24,
        textAlign: "right",
        fontSize: 11
    },
    footerSection: {
        paddingVertical: 8,
        fontSize: 11.5,
        marginVertical: 6
    },
    footerRow: {
        flexDirection: "row",
        justifyContent: "space-between"
    },
    footerColLeft: {
        flex: 1,
        justifyContent: "flex-start"
    },
    footerColCenter: {
        flex: 1,
        alignItems: "center"
    },
    footerColRight: {
        flex: 1,
        alignItems: "flex-end"
    },
    signSection: {
        paddingVertical: 8,
        fontSize: 11.5,
        marginVertical: 6,
        paddingHorizontal: 12
    },
    signRow: {
        flexDirection: "row",
        justifyContent: "space-between"
    },
    signCol: {
        flex: 1,
        alignItems: "center"
    },
    signLine: {
        color: "#d8d8d8",
        marginBottom: 4
    },
    signDate: {
        borderBottomWidth: 1,
        borderColor: "#d8d8d8",
        paddingHorizontal: 45,
        marginBottom: 4
    }
});
var PDFHeader = function() {
    return /*#__PURE__*/ _jsxs(View, {
        style: styles.headerRow,
        children: [
            /*#__PURE__*/ _jsx(Image, {
                style: styles.logo,
                src: "/images/logopardesco_new.png"
            }),
            /*#__PURE__*/ _jsxs(View, {
                style: {
                    flex: 1,
                    alignItems: "flex-end"
                },
                children: [
                    /*#__PURE__*/ _jsx(Text, {
                        style: styles.subTitle,
                        children: "(ต้นฉบับ)"
                    }),
                    /*#__PURE__*/ _jsx(Text, {
                        style: styles.title,
                        children: "ใบแจ้งหนี้"
                    })
                ]
            })
        ]
    });
};
var BillingPdf = function(param) {
    var data = param.data;
    var _data_BlDetail, _data_BlDetail1, _data_BlDetail2, _data_BlDetail3, _data_BlDetail4;
    console.log("BillingPdf data: ", data);
    var _useState = _sliced_to_array(useState(0), 2), sumrowTotalNet = _useState[0], setSumrowTotalNet = _useState[1];
    var _useState1 = _sliced_to_array(useState(1), 2), discounttype = _useState1[0], setDiscounttype = _useState1[1];
    var _useState2 = _sliced_to_array(useState(0), 2), discount = _useState2[0], setDiscount = _useState2[1];
    var _useState3 = _sliced_to_array(useState(0), 2), sumDiscount = _useState3[0], setSumDiscount = _useState3[1];
    var _useState4 = _sliced_to_array(useState(0), 2), sumrowVat = _useState4[0], setSumrowVat = _useState4[1];
    var _useState5 = _sliced_to_array(useState(0), 2), sumrowTax = _useState5[0], setSumrowTax = _useState5[1];
    var _useState6 = _sliced_to_array(useState(0), 2), totalnet = _useState6[0], setTotalnet = _useState6[1];
    var _useState7 = _sliced_to_array(useState(0), 2), taxAmount = _useState7[0], setTaxAmount = _useState7[1];
    var _useState8 = _sliced_to_array(useState({
        companyName: "",
        companyBranch: "",
        companyTaxId: "",
        companyAddress: "",
        companyProvince: "",
        companyDistrict: "",
        companySubDistrict: "",
        companyZipCode: "",
        contractName: "",
        contactPhone: "",
        contactEmail: ""
    }), 2), partnerInfo = _useState8[0], setPartnerInfo = _useState8[1];
    useEffect(function() {
        if (data) {
            setPartnerInfo({
                companyName: data.bl_billing_businesstype == 2 ? filterTextAndNum(data.bl_billing_comprefixname ? data.bl_billing_comprefixname : "") + " " + filterTextAndNum(data.bl_billing_name ? data.bl_billing_name : "") + " " + filterTextAndNum(data.bl_billing_suffixname ? data.bl_billing_suffixname : "") : filterTextAndNum(data.bl_billing_prefixid == 1 && "นาย" || data.bl_billing_prefixid == 2 && "นาง" || data.bl_billing_prefixid == 3 && "นางสาว" || data.bl_billing_prefixid == 4 && "ไม่ระบุ" || data.bl_billing_prefixid == "" && "") + " " + filterTextAndNum(data.bl_billing_fname) + " " + filterTextAndNum(data.bl_billing_lname),
                companyBranch: data.bl_billing_branchname ? data.bl_billing_branchname : "",
                companyTaxId: data.bl_billing_taxid ? data.bl_billing_taxid : "",
                companyAddress: data.bl_billing_address,
                companyProvince: data.Billprovinceid ? JSON.parse(data.Billprovinceid.province_name).th : "",
                companyDistrict: data.Billdistrictid ? JSON.parse(data.Billdistrictid.subdistrict_name).th : "",
                companySubDistrict: data.Billsubprovinceid ? JSON.parse(data.Billsubprovinceid.district_name).th : "",
                companyZipCode: data.bl_billing_zipcodeid ? data.bl_billing_zipcodeid : "",
                contractName: data.bl_billing_mainfname && data.bl_billing_mainlname ? data.bl_billing_mainfname + " " + data.bl_billing_mainlname : data.bl_billing_mainfname ? data.bl_billing_mainfname : data.bl_billing_mainlname ? data.bl_billing_mainlname : "",
                contactPhone: data.bl_billing_mainphone ? data.bl_billing_mainphone : "",
                contactEmail: data.bl_billing_mainemail ? data.bl_billing_mainemail : ""
            });
            setDiscounttype(data.bl_billing_discounttype ? data.bl_billing_discounttype : 1);
            setDiscount(data.bl_billing_discount ? data.bl_billing_discount : 0);
            setTotalnet(data.bl_billing_totalnet ? data.bl_billing_totalnet : 0);
            setSumDiscount(data.bl_billing_discountreal ? data.bl_billing_discountreal : 0);
            setSumrowTotalNet(data.bl_billing_pricediscount ? data.bl_billing_pricediscount : 0);
            setSumrowTax(data.bl_billing_totaltax ? data.bl_billing_totaltax : 0);
            setSumrowVat(data.bl_billing_totalvat ? data.bl_billing_totalvat : 0);
            setTaxAmount(data.bl_billing_tax ? data.bl_billing_tax : 0);
        }
    }, [
        data
    ]);
    return /*#__PURE__*/ _jsx(Document, {
        children: /*#__PURE__*/ _jsxs(Page, {
            size: "A4",
            style: styles.page,
            children: [
                /*#__PURE__*/ _jsx(PDFHeader, {}),
                /*#__PURE__*/ _jsxs(View, {
                    style: {
                        flexDirection: "row",
                        marginTop: 3
                    },
                    children: [
                        /*#__PURE__*/ _jsxs(View, {
                            style: {
                                width: 250,
                                borderBottom: "1px solid #ebecec",
                                paddingRight: 10
                            },
                            children: [
                                /*#__PURE__*/ _jsxs(View, {
                                    style: {
                                        flexDirection: "row",
                                        marginBottom: 4
                                    },
                                    children: [
                                        /*#__PURE__*/ _jsx(Text, {
                                            style: {
                                                width: 30
                                            },
                                            children: "ผู้ขาย :"
                                        }),
                                        /*#__PURE__*/ _jsx(Text, {
                                            style: {
                                                flex: 1
                                            },
                                            children: "บริษัท พาร์เดสโก้ กรุ๊ป จำากัด (สำนักงานใหญ่)"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ _jsxs(View, {
                                    style: {
                                        flexDirection: "row",
                                        marginBottom: 4
                                    },
                                    children: [
                                        /*#__PURE__*/ _jsx(Text, {
                                            style: {
                                                width: 30
                                            },
                                            children: "ที่อยู่ :"
                                        }),
                                        /*#__PURE__*/ _jsx(Text, {
                                            style: {
                                                flex: 1
                                            },
                                            children: "241/54 ซอยกาญจนาภิเษก 0015 แขวงศาลาธรรมสพน์ เขตทวีวัฒนา กรุงเทพ 10170"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ _jsxs(View, {
                                    style: {
                                        flexDirection: "row"
                                    },
                                    children: [
                                        /*#__PURE__*/ _jsx(Text, {
                                            style: {
                                                width: 80
                                            },
                                            children: "เลขประจำตัวผู้เสียภาษี :"
                                        }),
                                        /*#__PURE__*/ _jsx(Text, {
                                            style: {
                                                flex: 1
                                            },
                                            children: "0105568029236"
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ _jsxs(View, {
                            style: {
                                width: 150,
                                borderBottom: "1px solid #ebecec",
                                paddingRight: 10
                            },
                            children: [
                                /*#__PURE__*/ _jsxs(View, {
                                    style: {
                                        flexDirection: "row",
                                        marginBottom: 4
                                    },
                                    children: [
                                        /*#__PURE__*/ _jsx(Text, {
                                            style: {
                                                width: 30
                                            },
                                            children: "ติดต่อ :"
                                        }),
                                        /*#__PURE__*/ _jsx(Text, {
                                            style: {
                                                flex: 1
                                            },
                                            children: "วริธร สวยงาม"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ _jsxs(View, {
                                    style: {
                                        flexDirection: "row",
                                        marginBottom: 4
                                    },
                                    children: [
                                        /*#__PURE__*/ _jsx(Text, {
                                            style: {
                                                width: 30
                                            },
                                            children: "โทร."
                                        }),
                                        /*#__PURE__*/ _jsx(Text, {
                                            children: "0949280297"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ _jsxs(View, {
                                    style: {
                                        flexDirection: "row",
                                        marginBottom: 4
                                    },
                                    children: [
                                        /*#__PURE__*/ _jsx(Text, {
                                            style: {
                                                width: 30
                                            },
                                            children: "อีเมล์."
                                        }),
                                        /*#__PURE__*/ _jsx(Text, {
                                            children: "-"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ _jsxs(View, {
                                    style: {
                                        flexDirection: "row"
                                    },
                                    children: [
                                        /*#__PURE__*/ _jsx(Text, {
                                            style: {
                                                width: 30
                                            },
                                            children: "ลิงก์."
                                        }),
                                        /*#__PURE__*/ _jsx(Text, {
                                            children: "-"
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ _jsxs(View, {
                            style: {
                                backgroundColor: "#F6E1E3",
                                borderRadius: 5,
                                padding: 6,
                                width: 150
                            },
                            children: [
                                /*#__PURE__*/ _jsxs(View, {
                                    style: {
                                        flexDirection: "row",
                                        marginBottom: 4
                                    },
                                    children: [
                                        /*#__PURE__*/ _jsx(Text, {
                                            style: {
                                                width: 60
                                            },
                                            children: "เลขที่เอกสาร :"
                                        }),
                                        /*#__PURE__*/ _jsx(Text, {
                                            style: {
                                                flex: 1
                                            },
                                            children: data.bl_billing_code
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ _jsxs(View, {
                                    style: {
                                        flexDirection: "row",
                                        marginBottom: 4
                                    },
                                    children: [
                                        /*#__PURE__*/ _jsx(Text, {
                                            style: {
                                                width: 60
                                            },
                                            children: "วันที่ออกเอกสาร :"
                                        }),
                                        /*#__PURE__*/ _jsx(Text, {
                                            style: {
                                                flex: 1
                                            },
                                            children: moment(data.bl_billing_issuedate).format("DD/MM/YYYY")
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ _jsxs(View, {
                                    style: {
                                        flexDirection: "row",
                                        marginBottom: 4
                                    },
                                    children: [
                                        /*#__PURE__*/ _jsx(Text, {
                                            style: {
                                                width: 60
                                            },
                                            children: "วันที่ครบกำหนด :"
                                        }),
                                        /*#__PURE__*/ _jsx(Text, {
                                            style: {
                                                flex: 1
                                            },
                                            children: moment(data.bl_billing_expiredate).format("DD/MM/YYYY")
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ _jsxs(View, {
                                    style: {
                                        flexDirection: "row"
                                    },
                                    children: [
                                        /*#__PURE__*/ _jsx(Text, {
                                            style: {
                                                width: 60
                                            },
                                            children: "อ้างอิง :"
                                        }),
                                        /*#__PURE__*/ _jsx(Text, {
                                            style: {
                                                flex: 1
                                            },
                                            children: data.QrQuotation ? data.QrQuotation.qr_quotation_code : "-"
                                        })
                                    ]
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ _jsxs(View, {
                    style: {
                        flexDirection: "row",
                        marginTop: 3
                    },
                    children: [
                        /*#__PURE__*/ _jsxs(View, {
                            style: {
                                width: 240,
                                paddingRight: 10
                            },
                            children: [
                                /*#__PURE__*/ _jsxs(View, {
                                    style: {
                                        flexDirection: "row",
                                        marginBottom: 4
                                    },
                                    children: [
                                        /*#__PURE__*/ _jsx(Text, {
                                            style: {
                                                width: 30
                                            },
                                            children: "ลูกค้า :"
                                        }),
                                        /*#__PURE__*/ _jsxs(Text, {
                                            style: {
                                                flex: 1
                                            },
                                            children: [
                                                partnerInfo.companyName,
                                                " ",
                                                partnerInfo.companyBranch ? "(สาขา".concat(partnerInfo.companyBranch, ")") : ""
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ _jsxs(View, {
                                    style: {
                                        flexDirection: "row",
                                        marginBottom: 4
                                    },
                                    children: [
                                        /*#__PURE__*/ _jsx(Text, {
                                            style: {
                                                width: 30
                                            },
                                            children: "ที่อยู่ :"
                                        }),
                                        /*#__PURE__*/ _jsxs(Text, {
                                            style: {
                                                flex: 1
                                            },
                                            children: [
                                                partnerInfo.companyAddress + " " + partnerInfo.companySubDistrict,
                                                " ",
                                                partnerInfo.companyDistrict + " " + partnerInfo.companyProvince + " " + partnerInfo.companyZipCode
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ _jsxs(View, {
                                    style: {
                                        flexDirection: "row",
                                        marginBottom: 4
                                    },
                                    children: [
                                        /*#__PURE__*/ _jsx(Text, {
                                            style: {
                                                width: 80
                                            },
                                            children: "เลขประจำตัวผู้เสียภาษี :"
                                        }),
                                        /*#__PURE__*/ _jsx(Text, {
                                            style: {
                                                flex: 1
                                            },
                                            children: partnerInfo.companyTaxId ? partnerInfo.companyTaxId : "-"
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ _jsxs(View, {
                            style: {
                                width: 150,
                                paddingRight: 10
                            },
                            children: [
                                /*#__PURE__*/ _jsxs(View, {
                                    style: {
                                        flexDirection: "row",
                                        marginBottom: 4
                                    },
                                    children: [
                                        /*#__PURE__*/ _jsx(Text, {
                                            style: {
                                                width: 30
                                            },
                                            children: "ผู้ติดต่อ :"
                                        }),
                                        /*#__PURE__*/ _jsx(Text, {
                                            style: {
                                                flex: 1
                                            },
                                            children: partnerInfo.contractName
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ _jsxs(View, {
                                    style: {
                                        flexDirection: "row",
                                        marginBottom: 4
                                    },
                                    children: [
                                        /*#__PURE__*/ _jsx(Text, {
                                            style: {
                                                width: 30
                                            },
                                            children: "โทร."
                                        }),
                                        /*#__PURE__*/ _jsx(Text, {
                                            children: partnerInfo.contactPhone
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ _jsxs(View, {
                                    style: {
                                        flexDirection: "row",
                                        marginBottom: 4
                                    },
                                    children: [
                                        /*#__PURE__*/ _jsx(Text, {
                                            style: {
                                                width: 30
                                            },
                                            children: "อีเมล์."
                                        }),
                                        /*#__PURE__*/ _jsx(Text, {
                                            children: partnerInfo.contactEmail
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ _jsxs(View, {
                                    style: {
                                        flexDirection: "row",
                                        marginBottom: 4
                                    },
                                    children: [
                                        /*#__PURE__*/ _jsx(Text, {
                                            style: {
                                                width: 30
                                            },
                                            children: "ลิงก์."
                                        }),
                                        /*#__PURE__*/ _jsx(Text, {
                                            children: "-"
                                        })
                                    ]
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ _jsxs(View, {
                    style: styles.table,
                    children: [
                        /*#__PURE__*/ _jsx(View, {
                            style: styles.tableRow,
                            children: [
                                "รายการ",
                                "จำนวน",
                                "ราคาต่อหน่วย",
                                "ส่วนลด",
                                "ราคารวม"
                            ].map(function(h, i) {
                                return /*#__PURE__*/ _jsx(Text, {
                                    style: styles.tableHeader,
                                    children: h
                                }, i);
                            })
                        }),
                        (data === null || data === void 0 ? void 0 : data.BlDetail) && (data === null || data === void 0 ? void 0 : (_data_BlDetail = data.BlDetail) === null || _data_BlDetail === void 0 ? void 0 : _data_BlDetail.length) > 0 ? data === null || data === void 0 ? void 0 : (_data_BlDetail1 = data.BlDetail) === null || _data_BlDetail1 === void 0 ? void 0 : _data_BlDetail1.map(function(ele, i) {
                            return /*#__PURE__*/ _jsxs(View, {
                                style: styles.tableRow,
                                children: [
                                    /*#__PURE__*/ _jsxs(View, {
                                        style: [
                                            styles.tableCell,
                                            {
                                                alignItems: "flex-start"
                                            }
                                        ],
                                        children: [
                                            /*#__PURE__*/ _jsx(Text, {
                                                children: "".concat(i + 1, ". ").concat(ele.bl_detail_name)
                                            }),
                                            /*#__PURE__*/ _jsx(Text, {
                                                children: ele.bl_detail_remark ? "(" + ele.bl_detail_remark + ")" : ""
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ _jsx(View, {
                                        style: styles.tableCell,
                                        children: /*#__PURE__*/ _jsx(Text, {
                                            children: ele.bl_detail_amount
                                        })
                                    }),
                                    /*#__PURE__*/ _jsx(View, {
                                        style: styles.tableCell,
                                        children: /*#__PURE__*/ _jsx(Text, {
                                            children: NumberFormat(ele.bl_detail_price, 2)
                                        })
                                    }),
                                    /*#__PURE__*/ _jsx(View, {
                                        style: styles.tableCell,
                                        children: /*#__PURE__*/ _jsx(Text, {
                                            children: ele.bl_detail_discounttype == 1 ? NumberFormat(ele.bl_detail_discount, 2) : ele.bl_detail_discount + "%"
                                        })
                                    }),
                                    /*#__PURE__*/ _jsx(View, {
                                        style: styles.tableCell,
                                        children: /*#__PURE__*/ _jsx(Text, {
                                            children: NumberFormat(ele.bl_detail_net, 2)
                                        })
                                    })
                                ]
                            }, i);
                        }) : /*#__PURE__*/ _jsx(View, {
                            style: styles.tableRow,
                            children: /*#__PURE__*/ _jsx(Text, {
                                style: [
                                    styles.tableCell,
                                    {
                                        flex: 1
                                    }
                                ],
                                children: "ไม่พบข้อมูล"
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ _jsxs(View, {
                    style: {
                        flexDirection: "row",
                        marginTop: ((_data_BlDetail2 = data.BlDetail) === null || _data_BlDetail2 === void 0 ? void 0 : _data_BlDetail2.length) > 5 && 100 || ((_data_BlDetail3 = data.BlDetail) === null || _data_BlDetail3 === void 0 ? void 0 : _data_BlDetail3.length) < 5 && 100 || ((_data_BlDetail4 = data.BlDetail) === null || _data_BlDetail4 === void 0 ? void 0 : _data_BlDetail4.length) > 10 && 10,
                        borderBottom: "1px solid #ebecec",
                        borderTop: "1px solid #ebecec",
                        padding: "10px 2px"
                    },
                    children: [
                        /*#__PURE__*/ _jsx(View, {
                            style: {
                                width: 40,
                                paddingRight: 10
                            },
                            children: /*#__PURE__*/ _jsx(View, {
                                style: {
                                    width: 40,
                                    paddingRight: 10
                                },
                                children: /*#__PURE__*/ _jsx(View, {
                                    style: {
                                        flexDirection: "row",
                                        marginBottom: 4,
                                        fontWeight: "bold"
                                    },
                                    children: /*#__PURE__*/ _jsx(Text, {
                                        style: {
                                            width: 30
                                        },
                                        children: "สรุป"
                                    })
                                })
                            })
                        }),
                        /*#__PURE__*/ _jsxs(View, {
                            style: {
                                width: 250,
                                paddingRight: 10
                            },
                            children: [
                                /*#__PURE__*/ _jsxs(View, {
                                    style: {
                                        flexDirection: "row",
                                        marginBottom: 4
                                    },
                                    children: [
                                        /*#__PURE__*/ _jsx(Text, {
                                            style: {
                                                width: 120
                                            },
                                            children: "มูลค่าสินค้าก่อนส่วนลด"
                                        }),
                                        /*#__PURE__*/ _jsx(Text, {
                                            style: [
                                                styles.textEnd,
                                                {
                                                    width: 50,
                                                    marginRight: 3,
                                                    fontWeight: "bold"
                                                }
                                            ],
                                            children: NumberFormat(sumrowTotalNet, 2)
                                        }),
                                        /*#__PURE__*/ _jsx(Text, {
                                            style: {
                                                flex: 1
                                            },
                                            children: "บาท"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ _jsxs(View, {
                                    style: {
                                        flexDirection: "row",
                                        marginBottom: 4
                                    },
                                    children: [
                                        /*#__PURE__*/ _jsxs(Text, {
                                            style: {
                                                width: 120
                                            },
                                            children: [
                                                "ส่วนลด",
                                                " ",
                                                discounttype == 1 ? NumberFormat(discount, 2) : discount,
                                                " ",
                                                discounttype == 1 ? "บาท" : "เปอร์เซ็น"
                                            ]
                                        }),
                                        /*#__PURE__*/ _jsx(Text, {
                                            style: [
                                                styles.textEnd,
                                                {
                                                    width: 50,
                                                    marginRight: 3,
                                                    fontWeight: "bold"
                                                }
                                            ],
                                            children: NumberFormat(sumDiscount, 2)
                                        }),
                                        /*#__PURE__*/ _jsx(Text, {
                                            style: {
                                                flex: 1
                                            },
                                            children: "บาท"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ _jsxs(View, {
                                    style: {
                                        flexDirection: "row",
                                        marginBottom: 4
                                    },
                                    children: [
                                        /*#__PURE__*/ _jsx(Text, {
                                            style: {
                                                width: 120
                                            },
                                            children: "มูลค่าสินค้าหลังหักส่วนลด"
                                        }),
                                        /*#__PURE__*/ _jsx(Text, {
                                            style: [
                                                styles.textEnd,
                                                {
                                                    width: 50,
                                                    marginRight: 3,
                                                    fontWeight: "bold"
                                                }
                                            ],
                                            children: NumberFormat(sumrowTotalNet - sumDiscount, 2)
                                        }),
                                        /*#__PURE__*/ _jsx(Text, {
                                            style: {
                                                flex: 1
                                            },
                                            children: "บาท"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ _jsxs(View, {
                                    style: {
                                        flexDirection: "row",
                                        marginBottom: 4
                                    },
                                    children: [
                                        /*#__PURE__*/ _jsx(Text, {
                                            style: {
                                                width: 120
                                            },
                                            children: "ภาษีมูลค่าเพิ่ม"
                                        }),
                                        /*#__PURE__*/ _jsx(Text, {
                                            style: [
                                                styles.textEnd,
                                                {
                                                    width: 50,
                                                    marginRight: 3,
                                                    fontWeight: "bold"
                                                }
                                            ],
                                            children: NumberFormat(sumrowVat, 2)
                                        }),
                                        /*#__PURE__*/ _jsx(Text, {
                                            style: {
                                                flex: 1
                                            },
                                            children: "บาท"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ _jsxs(View, {
                                    style: {
                                        flexDirection: "row",
                                        marginBottom: 4
                                    },
                                    children: [
                                        /*#__PURE__*/ _jsx(Text, {
                                            style: {
                                                width: 120
                                            },
                                            children: "มูลค่าสินค้ารวมภาษีมูลค่าเพิ่ม"
                                        }),
                                        /*#__PURE__*/ _jsx(Text, {
                                            style: [
                                                styles.textEnd,
                                                {
                                                    width: 50,
                                                    marginRight: 3,
                                                    fontWeight: "bold"
                                                }
                                            ],
                                            children: NumberFormat(sumrowTotalNet - sumDiscount + sumrowVat, 2)
                                        }),
                                        /*#__PURE__*/ _jsx(Text, {
                                            style: {
                                                flex: 1
                                            },
                                            children: "บาท"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ _jsxs(View, {
                                    style: {
                                        flexDirection: "row"
                                    },
                                    children: [
                                        /*#__PURE__*/ _jsxs(Text, {
                                            style: {
                                                width: 120
                                            },
                                            children: [
                                                "หัก ณ ที่จ่าย ",
                                                taxAmount,
                                                "%"
                                            ]
                                        }),
                                        /*#__PURE__*/ _jsx(Text, {
                                            style: [
                                                styles.textEnd,
                                                {
                                                    width: 50,
                                                    marginRight: 3,
                                                    fontWeight: "bold"
                                                }
                                            ],
                                            children: NumberFormat(sumrowTax, 2)
                                        }),
                                        /*#__PURE__*/ _jsx(Text, {
                                            style: {
                                                flex: 1
                                            },
                                            children: "บาท"
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ _jsx(View, {
                            style: [
                                styles.docValue,
                                {
                                    width: 200,
                                    paddingRight: 10,
                                    fontSize: 13
                                }
                            ],
                            children: /*#__PURE__*/ _jsxs(View, {
                                style: {
                                    backgroundColor: "#F6E1E3",
                                    borderRadius: 5,
                                    padding: 6
                                },
                                children: [
                                    /*#__PURE__*/ _jsxs(View, {
                                        style: {
                                            flexDirection: "row",
                                            marginBottom: 4
                                        },
                                        children: [
                                            /*#__PURE__*/ _jsx(Text, {
                                                style: {
                                                    width: 100
                                                },
                                                children: "มูลค่าสุทธิรวม"
                                            }),
                                            /*#__PURE__*/ _jsx(Text, {
                                                style: [
                                                    styles.textEnd,
                                                    {
                                                        width: 50,
                                                        marginRight: 3,
                                                        color: "#b00412",
                                                        fontWeight: 700
                                                    }
                                                ],
                                                children: NumberFormat(totalnet, 2)
                                            }),
                                            /*#__PURE__*/ _jsx(Text, {
                                                style: {
                                                    flex: 1
                                                },
                                                children: "บาท"
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ _jsx(View, {
                                        style: [
                                            styles.titleCenter,
                                            {
                                                flexDirection: "row",
                                                marginBottom: 4
                                            }
                                        ],
                                        children: /*#__PURE__*/ _jsxs(Text, {
                                            style: {
                                                width: 200
                                            },
                                            children: [
                                                "( ",
                                                ThaiBahtText(totalnet, 2),
                                                " )"
                                            ]
                                        })
                                    })
                                ]
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ _jsxs(View, {
                    style: {
                        flexDirection: "row",
                        borderBottom: "1px solid #ebecec",
                        marginTop: 3
                    },
                    children: [
                        /*#__PURE__*/ _jsx(View, {
                            style: {
                                width: 40,
                                paddingRight: 10
                            },
                            children: /*#__PURE__*/ _jsx(View, {
                                style: {
                                    flexDirection: "row",
                                    marginBottom: 4,
                                    fontWeight: "bold"
                                },
                                children: /*#__PURE__*/ _jsx(Text, {
                                    style: {
                                        width: 40
                                    },
                                    children: "ชำระเงิน"
                                })
                            })
                        }),
                        /*#__PURE__*/ _jsx(View, {
                            style: {
                                width: 40,
                                paddingRight: 10
                            },
                            children: /*#__PURE__*/ _jsx(View, {
                                style: {
                                    flexDirection: "row",
                                    marginBottom: 4,
                                    paddingTop: 2
                                },
                                children: /*#__PURE__*/ _jsx(Image, {
                                    src: "/images/bankkbank.png",
                                    style: styles.logoBank
                                })
                            })
                        }),
                        /*#__PURE__*/ _jsxs(View, {
                            style: {
                                width: 250,
                                paddingRight: 10
                            },
                            children: [
                                /*#__PURE__*/ _jsx(View, {
                                    style: {
                                        flexDirection: "row",
                                        marginBottom: 2
                                    },
                                    children: /*#__PURE__*/ _jsx(Text, {
                                        style: {
                                            width: 200
                                        },
                                        children: "ธ.กสิกรไทย ( ถนนแจ้งวัฒนะ )"
                                    })
                                }),
                                /*#__PURE__*/ _jsxs(View, {
                                    style: {
                                        flexDirection: "row",
                                        marginBottom: 2
                                    },
                                    children: [
                                        /*#__PURE__*/ _jsx(Text, {
                                            style: {
                                                width: 50
                                            },
                                            children: "กระแสรายวัน"
                                        }),
                                        /*#__PURE__*/ _jsx(Text, {
                                            style: {
                                                flex: 1,
                                                color: "#b00412",
                                                fontWeight: "700"
                                            },
                                            children: "203-1-87899-6"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ _jsx(View, {
                                    style: {
                                        flexDirection: "row",
                                        marginBottom: 2
                                    },
                                    children: /*#__PURE__*/ _jsx(Text, {
                                        style: {
                                            width: 200
                                        },
                                        children: "บจก.พาร์เดสโก้ กรุ๊ป"
                                    })
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ _jsx(View, {
                    style: {
                        flexDirection: "row",
                        marginTop: 3
                    },
                    children: /*#__PURE__*/ _jsxs(View, {
                        style: {
                            width: 40,
                            paddingRight: 10
                        },
                        children: [
                            /*#__PURE__*/ _jsx(View, {
                                style: {
                                    flexDirection: "row",
                                    marginBottom: 4,
                                    fontWeight: "bold"
                                },
                                children: /*#__PURE__*/ _jsx(Text, {
                                    style: {
                                        width: 40
                                    },
                                    children: "หมายเหตุ"
                                })
                            }),
                            /*#__PURE__*/ _jsx(View, {
                                style: {
                                    width: 250,
                                    paddingRight: 10
                                },
                                children: /*#__PURE__*/ _jsx(View, {
                                    style: {
                                        flexDirection: "row",
                                        marginBottom: 1
                                    },
                                    children: /*#__PURE__*/ _jsx(Text, {
                                        children: data.bl_billing_ramark ? data.bl_billing_ramark : ""
                                    })
                                })
                            })
                        ]
                    })
                }),
                /*#__PURE__*/ _jsx(View, {
                    style: styles.footerSection,
                    children: /*#__PURE__*/ _jsxs(View, {
                        style: styles.footerRow,
                        children: [
                            /*#__PURE__*/ _jsx(View, {
                                style: styles.footerColLeft,
                                children: /*#__PURE__*/ _jsxs(Text, {
                                    children: [
                                        "ในนาม ",
                                        (partnerInfo === null || partnerInfo === void 0 ? void 0 : partnerInfo.companyName) || "-"
                                    ]
                                })
                            }),
                            /*#__PURE__*/ _jsx(View, {
                                style: styles.footerColCenter,
                                children: /*#__PURE__*/ _jsx(Text, {
                                    children: " "
                                })
                            }),
                            /*#__PURE__*/ _jsx(View, {
                                style: styles.footerColRight,
                                children: /*#__PURE__*/ _jsx(Text, {
                                    children: "ในนาม บริษัท พาร์เดสโก้ กรุ๊ป จำกัด"
                                })
                            })
                        ]
                    })
                }),
                /*#__PURE__*/ _jsx(View, {
                    style: styles.signSection,
                    children: /*#__PURE__*/ _jsxs(View, {
                        style: styles.signRow,
                        children: [
                            /*#__PURE__*/ _jsxs(View, {
                                style: styles.signCol,
                                children: [
                                    /*#__PURE__*/ _jsx(Text, {
                                        style: {
                                            marginBottom: 5
                                        }
                                    }),
                                    /*#__PURE__*/ _jsx(Text, {
                                        style: styles.signLine,
                                        children: "________________________________"
                                    }),
                                    /*#__PURE__*/ _jsx(Text, {
                                        children: "ผู้จ่าย"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ _jsxs(View, {
                                style: styles.signCol,
                                children: [
                                    /*#__PURE__*/ _jsx(Text, {
                                        style: {
                                            marginBottom: 5
                                        }
                                    }),
                                    /*#__PURE__*/ _jsx(Text, {
                                        style: styles.signLine,
                                        children: "________________________________"
                                    }),
                                    /*#__PURE__*/ _jsx(Text, {
                                        children: "วันที่"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ _jsx(View, {
                                style: styles.signCol,
                                children: /*#__PURE__*/ _jsx(Text, {
                                    children: " "
                                })
                            }),
                            /*#__PURE__*/ _jsxs(View, {
                                style: [
                                    styles.signCol,
                                    {
                                        paddingRight: 4
                                    }
                                ],
                                children: [
                                    /*#__PURE__*/ _jsx(Text, {
                                        style: {
                                            marginBottom: 5,
                                            width: "50%"
                                        }
                                    }),
                                    /*#__PURE__*/ _jsx(Text, {
                                        style: styles.signLine,
                                        children: "________________________________"
                                    }),
                                    /*#__PURE__*/ _jsx(Text, {
                                        children: "ผู้รับเงิน"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ _jsxs(View, {
                                style: styles.signCol,
                                children: [
                                    /*#__PURE__*/ _jsx(Text, {
                                        style: {
                                            marginBottom: 4,
                                            paddingLeft: 4,
                                            borderBottom: "1px soild #ebecec",
                                            width: "100%",
                                            textAlign: "center"
                                        },
                                        children: (data === null || data === void 0 ? void 0 : data.bl_billing_issuedate) ? moment(data.bl_billing_issuedate).format("DD/MM/YYYY") : ""
                                    }),
                                    /*#__PURE__*/ _jsx(Text, {
                                        children: "วันที่"
                                    })
                                ]
                            })
                        ]
                    })
                })
            ]
        })
    });
};
export default BillingPdf;
